/**
 * The signed-in learner's OWN profile photo for the header identity chip.
 * The blob is bearer-protected (an <img> can't carry the session), so the
 * photo comes back as an object URL; a miss (404/no photo) caches null and
 * the initials fallback renders without re-fetching. Module-level promise:
 * one fetch per tab. Chrome-level sibling of the forums surface's avatars.ts
 * — same contract, but self-scoped against the UNGATED /api/auth/me/photo so
 * every deployment shows it, forums enabled or not.
 */
import { apiFetch } from './auth'

let cached: Promise<string | null> | null = null

export function selfPhotoUrl(): Promise<string | null> {
  if (!cached) {
    cached = (async () => {
      try {
        const r = await apiFetch('/LearnerView/api/auth/me/photo')
        if (!r.ok) return null
        return URL.createObjectURL(await r.blob())
      } catch {
        return null
      }
    })()
  }
  return cached
}
